import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsComponentsRoute: InvariantJiraRoute = {
	name: 'project-settings-components',
	path: '/plugins/servlet/project-config/:projectKey/administer-components',
};
